var map = {
	"./decidim/avatar-multiuser.png": 32451,
	"./decidim/brands/facebook.svg": 3275,
	"./decidim/brands/google.svg": 49922,
	"./decidim/brands/twitter-x.svg": 19075,
	"./decidim/cc-badge.png": 11297,
	"./decidim/decidim-logo.svg": 86321,
	"./decidim/default-avatar.svg": 82289,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 62599,
	"./decidim/icons.svg": 80752,
	"./decidim/pattern.png": 94291,
	"./decidim/placeholder-card-g.svg": 9744,
	"./decidim/placeholder-card-l.svg": 3451,
	"./decidim/placeholder.jpg": 89554,
	"./decidim/remixicon.symbol.svg": 48840,
	"./decidim/vendor/social-share-button/douban.svg": 20123,
	"./decidim/vendor/social-share-button/email.svg": 20116,
	"./decidim/vendor/social-share-button/facebook.svg": 64176,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 45156,
	"./decidim/vendor/social-share-button/hacker_news.svg": 98360,
	"./decidim/vendor/social-share-button/linkedin.svg": 91218,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 52539,
	"./decidim/vendor/social-share-button/pinterest.svg": 83026,
	"./decidim/vendor/social-share-button/reddit.svg": 50856,
	"./decidim/vendor/social-share-button/telegram.svg": 24221,
	"./decidim/vendor/social-share-button/tumblr.svg": 82042,
	"./decidim/vendor/social-share-button/twitter.svg": 7377,
	"./decidim/vendor/social-share-button/vkontakte.svg": 35195,
	"./decidim/vendor/social-share-button/wechat.svg": 64665,
	"./decidim/vendor/social-share-button/whatsapp.svg": 33854,
	"./decidim/vendor/social-share-button/x.svg": 19948,
	"./decidim/vendor/social-share-button/xing.svg": 96140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70024;